<template>
    <b-card no-body>
      <div class="card-header">
        <b-icon-person></b-icon-person>
        {{ $t(title) }}
      </div>
      <b-list-group>
        <b-list-group-item>
          <b-button
            block
            variant="outline-primary"
            :href="
              'mailto:' + 
            email"
          >
            <b-icon-envelope></b-icon-envelope>
            {{ $t(emailBtnLabel) }} -
            {{ (email.indexOf('?') > 0 ? email.substr(0, email.indexOf('?')) : email) }}
          </b-button>
          <b-button block variant="outline-dark" :href="(telephoneLong) ? ('tel:' + telephoneLong) : ('tel:' + telephone)" v-if="telephone">
            <b-icon-telephone></b-icon-telephone> {{ $t(teleBtnLabel) + ' - ' + telephone }}
          </b-button>
        </b-list-group-item>
      </b-list-group>
    </b-card>
</template>
<script>
export default {
    props: {
        title: { 
            default: 'project_details.contact_customer',
            type: String,
        },
        email: { 
            default: '',
            type: String,
        },
        telephone: { 
            default: '',
            type: String,
        },
        telephoneLong: { 
            default: '',
            type: String,
        },
        emailBtnLabel: { 
            default: 'project_details.send_email',
            type: String,
        },
        teleBtnLabel: { 
            default: 'project_details.call_customer',
            type: String,
        },
    }
}
</script>